/**
 * NicLen.Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssignmentType } from './assignmentType';


export interface AssignmentDto { 
    Type: AssignmentType;
    AssignmentNo: number;
    ParentAssignmentNo?: number;
    EventAddress?: string;
    EventCity?: string;
    EventZipCode?: string;
    EventStreet?: string;
    EventDate?: string;
    EventTime?: string;
    EventCountry?: string;
    Weight: number;
    Volume: number;
    AusgabeGewicht?: number;
    AusgabeVolumen?: number;
    DispoWeight?: number;
    DispoVolume?: number;
    Sachbearbeiter?: string;
    T1?: string;
    T2?: string;
    TransportLabel?: AssignmentDto.TransportLabelEnum;
    DispoDateFrom?: string;
    DispoTimeFrom?: string;
    DispoDateTo?: string;
    DispoTimeTo?: string;
    FilterState?: number;
    IsPartialAssignment?: boolean;
    Statustext?: string;
    CanBeHidden?: boolean;
    IsDone?: boolean;
    MIAuftrag?: number;
    NumMIProbSolutions?: number;
    MIProbSolutionIDs?: string;
    AdrPoints?: number;
    TrapoProjectsAssignedTo?: Array<number>;
    IsPrimeLogistic?: boolean;
    IsPrimeLogisticStation?: boolean;
    StationFullyAssigned?: boolean;
    StationDispoVolume?: number;
    StationDispoWeight?: number;
}
export namespace AssignmentDto {
    export type TransportLabelEnum = 'NotSpecified' | 'NotFarAway' | 'FarAway';
    export const TransportLabelEnum = {
        NotSpecified: 'NotSpecified' as TransportLabelEnum,
        NotFarAway: 'NotFarAway' as TransportLabelEnum,
        FarAway: 'FarAway' as TransportLabelEnum
    };
}


